import { NavButtonsContainer } from "@src/common/styled-components";
import { Button } from "@uhg-abyss/web/ui/Button";

interface NavButtonsLegacyProps {
  isMobile: boolean;
  isSubmitting?: boolean;
  isUiBlocked?: boolean;
}

export const NavButtonsLegacy = ({
  isMobile,
  isSubmitting = false,
  isUiBlocked = false,
}: NavButtonsLegacyProps) => {
  return (
    <NavButtonsContainer isMobile={isMobile}>
      <Button
        name="requestCallback"
        size={isMobile ? "lg" : "md"}
        variant={isMobile ? "text" : "outline"}
        type="submit"
        form="refer-form"
        id="obc-refer-request-callback-button"
        data-testid="test-id-refer-request-callback-button"
        data-obc-label="Refer Request a Callback Button"
        isDisabled={isSubmitting || isUiBlocked}
      >
        Request a callback
      </Button>
      <Button
        name="scheduleNow"
        css={isMobile ? { width: "100%" } : undefined}
        icon={
          !isMobile
            ? { icon: "chevron_right", position: "trailing", variant: "outlined" }
            : undefined
        }
        size={isMobile ? "lg" : "md"}
        variant="filled"
        type="submit"
        form="refer-form"
        id="obc-refer-schedule-now-button"
        data-testid="test-id-refer-schedule-now-button"
        data-obc-label="Refer Schedule Now Button"
        isDisabled={isSubmitting || isUiBlocked}
      >
        Schedule now
      </Button>
    </NavButtonsContainer>
  );
};
